import React from 'react';
import { footerContent, companyInfo, logos } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-300 py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Brand */}
          <div className="flex flex-col items-start gap-4">
            <img 
              src={logos.dark} 
              alt={companyInfo.name}
              className="h-12 w-auto object-contain"
            />
            <p className="text-stone-400 font-light">
              {footerContent.tagline}
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-8 md:justify-end">
            {footerContent.links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-stone-400 hover:text-stone-200 transition-colors font-light"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="mt-12 pt-8 border-t border-stone-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-stone-500 text-sm font-light">
              {footerContent.copyright}
            </p>
            <p className="text-stone-600 text-xs tracking-wider">
              Lifestyle Accommodation Brand from Tokyo
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
